<template>
  <Navbar v-if="$route.name != 'Register' && $route.name != 'Login'" />
  <div class="container pt-3" v-else >
    <router-link class="navbar-brand" :to="{ name: 'Home' }"
      ><img src="@/assets/images/jadwellha.svg" alt=""
    /></router-link>
  </div>
  <router-view />
  <Footer />
<FloatingNav />
</template>

<script>
// @ is an alias to /src
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import FloatingNav from "./components/FloatingNav.vue";

export default {
  name: "Home",
  components: {
    Navbar,
    Footer,
    FloatingNav
  },
  setup() {},
    created(){
       let htmlEl=document.querySelector("html");
        htmlEl.setAttribute('dir','rtl');
        htmlEl.setAttribute('lang','ar');
      }
};
</script>
<style lang="scss">

</style>
